// extracted by mini-css-extract-plugin
export default {"content":"share-modal_content__wmaNh patterns_scrollBody__ksWzg"};